import { ChainedCommands, Editor } from '@tiptap/react';

/** One intent-named helper instead of scattered casts: TipTap v3's `Commands` isn't augmentable here. */

interface ChainWithInsertMath extends ChainedCommands {
  insertMath: (latex?: string) => ChainWithInsertMath;
}

export const insertMathCommand = (editor: Editor, latex: string = ''): boolean =>
  (editor.chain().focus() as unknown as ChainWithInsertMath)
    .insertMath(latex)
    .run();
